module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_3-5e95a134875f8d5a656e3e449e9d2b1e.png";